/*
 * @Description: 
 * @Version: 2.0
 * @Autor: 一诺(丘汉文)
 * @Date: 2019-03-26 23:15:52
 * @Author: 一诺(丘汉文)
 * @LastEditors: lkz
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/newbusiness/bbx',
    name: '/bbx',
    meta: {
      title: '百宝箱配置'
    },
    component: () => import(/* webpackChunkName: "example-newbusiness" */ '../views/newbusiness/bbx.vue')
  },
  {
    path: '/newbusiness/personal',
    name: '/personal',
    meta: {
      title: '个人中心配置'
    },
    component: () => import(/* webpackChunkName: "example-newbusiness" */ '../views/newbusiness/personal.vue')
  },
  {
    path: '/newbusiness/button',
    name: '/button',
    meta: {
      title: '订单/售后按钮'
    },
    component: () => import(/* webpackChunkName: "example-newbusiness" */ '../views/newbusiness/button.vue')
  },
  {
    path: '/newbusiness/edit',
    name: '/edit',
    meta: {
      title: '新增/编辑'
    },
    component: () => import(/* webpackChunkName: "example-newbusiness" */ '../views/newbusiness/edit.vue')
  }
]
